import { REDUCER_NAME } from './constants';
import { getRootState } from '../selectors';

const getState = state => getRootState(state)[REDUCER_NAME];

export const getShipment = state => getState(state).shipment;

export const getIsFetching = state => getState(state).isFetching;

export const getShipmentLoadingStatus = state => getState(state).shipmentFailedToLoad;
